import { Avatar, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/system';
import Logo from '../../images/logo/logo.png';

export const AdminHeader = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        bgcolor: 'var(--drawer-bgcolor)',
        mb: 2,
      }}
    >
      <Container>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pt: 0.6,
          }}
        >
          <Box
            sx={{
              cursor: 'pointer',
              height: { xs: '70px', md: '100px' },
            }}
            onClick={() => navigate('/dashboard')}
          >
            <img src={Logo} alt="logo" style={{ height: '90%' }} />
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: 'var(--yello-color)',
            }}
          >
            <Avatar sx={{ bgcolor: 'var(--yello-color)' }}>A</Avatar>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
